import React from 'react';
import { StyleSheet, View } from 'react-native';
import Text from 'design-system/Text';
import { rem } from 'design-system';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
const strings = {
    title: 'Search by topic or\nfeature name',
    subtitle: 'Start typing your keywords',
};
const SearchHelpEmptyComponent = () => {
    const { height } = useAppFrameDimensions();
    return (<View style={[
            styles.container,
            {
                marginTop: 0.2 * height,
            },
        ]}>
      <Text Text-16 centered>
        {strings.title}
      </Text>
      <Text TextThin-14 Secondary centered>
        {strings.subtitle}
      </Text>
    </View>);
};
const styles = StyleSheet.create({
    container: {
        gap: rem(8),
    },
});
export default SearchHelpEmptyComponent;
